export default function arrayHasObject(array, object) {
    return Boolean(array.find(item => {
        return JSON.stringify(item) === JSON.stringify(object);
    }));
}